import { getInsuranceCountryTwoLetterCodeByName } from '@luxuryescapes/lib-regions'

const regionNamesByLocale = new Map<string, Intl.DisplayNames>()

function getRegionDisplayNames(locale: string): Intl.DisplayNames | null {
  if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') {
    return null
  }

  const cached = regionNamesByLocale.get(locale)
  if (cached) {
    return cached
  }

  try {
    const displayNames = new Intl.DisplayNames([locale], { type: 'region', fallback: 'code' })
    regionNamesByLocale.set(locale, displayNames)
    return displayNames
  } catch {
    return null
  }
}

export function formatRegionName(
  regionCode: string,
  locale = 'en',
  fallback: string = regionCode,
): string {
  try {
    return getRegionDisplayNames(locale)?.of(regionCode) ?? fallback
  } catch {
    return fallback
  }
}

export function formatCountryName(englishCountryName: string, locale: string): string {
  const regionCode = getInsuranceCountryTwoLetterCodeByName(englishCountryName)
  if (!regionCode) {
    return englishCountryName
  }

  return formatRegionName(regionCode, locale, englishCountryName)
}
